export default {
      id: "filterArrow-usage",
      viewBox: "0 0 11 8",
      url: __webpack_public_path__ + "sprite.1793797381340.svg#filterArrow-usage",
      toString: function () {
        return this.url;
      }
    }